import { useContext } from 'react'

import { MrpOportunityContext } from '@provider/Mrp/OportunityProvider'

import type { IMrpOportunityContext } from '@base/@types/providers/Mrp/OportunityProvider'

export default function useMrpOportunity(): IMrpOportunityContext {
  const context = useContext(MrpOportunityContext)

  return context
}
